import React, {useEffect} from "react";
import {MTableBodyRow} from 'material-table';
import {useDispatch, useSelector, connect} from "react-redux";
import {Edit, PlayCircleFilled} from "@material-ui/icons";
import {refreshOne, setCheckedRows, uncheckRow} from "../store/raspberryEraseStationSlice";
import * as raspberryEraseStationActions from "../store/raspberryEraseStationActions";
import {withStyles} from "@material-ui/core";
import {socket} from "../../../../index";

const styles = theme => ({
    eraseStatus: {
        fontSize: "14px",
    }
});

const sessionActions = ['start-session', 'abort-session', 'erase-status'];

const checkIfHasAction = (actions, actionName) => {
    return actions.find((action) => action.name === actionName)
}

const removePreviousSessionAction = (actions) => {
    return actions.filter((action) => !sessionActions.includes(action.name));
}

const RaspberryEraseStationListRow = (props) => {
    const {id, translations, startSession, activeCustomerID} = props;

    // store
    const raspberryEraseStation = useSelector((state) => state.raspberryEraseStation.list[id]);
    const dispatch = useDispatch();

    const storeData = {
        ...props.data,
        ...raspberryEraseStation
    }

    useEffect(() => {
        socket.on("raspberry-status-changed", async msg => {
            if (msg?.EraseStationID === id) {
                if (msg.InventoryID) {
                    handleRefreshOne(msg);
                } else {
                    handleChangeStatus(msg.Status?? "ready");
                }
            }
        })

        return () => {
            socket.off("raspberry-status-changed");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChangeStatus = (status) => {
        dispatch(refreshOne({id, raspberryEraseStation: {...raspberryEraseStation, sessionStatus: status}}));
    }

    const handleRefreshOne = (Details) => {
        dispatch(refreshOne({id, raspberryEraseStation: {...raspberryEraseStation, Details: JSON.stringify(Details), sessionStatus: Details.Status}}));
    }

    const handleStartSession = async () => {
        const result = await startSession({ActiveCustomerID: activeCustomerID, RaspberryEraseStationID: id});
        if (result) {
            handleChangeStatus("starting");
        }
    }

    // const handleAbortSession = async () => {
    //     const result = await abortSession({ActiveCustomerID: activeCustomerID, RaspberryEraseStationID: id});
    //     if (result) {
    //         handleChangeStatus("aborted");
    //     }
    // }

    let propsCopy = {...props};

    // session actions
    const startSessionAction = {
        name: 'start-session',
        icon: PlayCircleFilled,
        tooltip: translations['start_session'] || 'Start session',
        onClick: () => handleStartSession(),
        disabled: !propsCopy.data.SocketID,
        position: "row"
    }
    // const abortSessionAction = {
    //     name: 'abort-session',
    //     icon: Stop,
    //     tooltip: translations['abort_session'] || 'Abort session',
    //     onClick: () => handleAbortSession(),
    //     disabled: false,
    //     position: "row"
    // }

    const sessionStatus = raspberryEraseStation?.sessionStatus;
    // showing start or abort erasure action
    if ((!sessionStatus || ["ready", "starting", "analyze", "aborted", "completed", "error", "erasure_inprogress"].includes(sessionStatus)) && !checkIfHasAction(propsCopy.actions, "start-session")) {
        propsCopy.actions = [startSessionAction, ...removePreviousSessionAction(propsCopy.actions)];
    }
    // else if (sessionStatus === "erasure_inprogress" && !checkIfHasAction(propsCopy.actions, "abort-session")) {
    //     propsCopy.actions = [abortSessionAction, ...removePreviousSessionAction(propsCopy.actions)];
    // }

    // default actions
    const detailsAction = propsCopy.actions.find(a => a.name === 'details');
    if (detailsAction) {
        detailsAction.disabled = false;
    }
    // const revokeAction = propsCopy.actions.find(a => a.name === 'revoke');
    // if (revokeAction) {
    //     propsCopy.actions.find(a => a.name === 'revoke').disabled = !propsCopy.data.ApiKey;
    // }
    const getDebugLogsAction = propsCopy.actions.find(a => a.name === 'get-debug-logs');
    if (getDebugLogsAction) {
        getDebugLogsAction.disabled = !propsCopy.data.SocketID;
    }

    const dispatchCheckedRows = () => {
        if (["starting", "analyze"].includes(sessionStatus)) {
            dispatch(setCheckedRows(propsCopy.data.tableData.id));
        } else {
            dispatch(uncheckRow(propsCopy.data.tableData.id));
        }
    }

    // disable all table actions
    if (["starting", "analyze"].includes(sessionStatus)) {
        propsCopy.actions.map((action) => action.disabled = true);

        // replacing edit with disabled one
        propsCopy.actions = propsCopy.actions.filter((action) => typeof action !== 'function');
        propsCopy.actions.push({
            name: 'disabled-edit',
            icon: Edit,
            tooltip: translations["edit"] || "Edit",
            disabled: true,
            position: "row"
        })
        propsCopy.options.selectionProps = () => {
            return {
                disabled: true,
                checked: false
            }
        }

        propsCopy.options.selectionProps = () => {
            return {
                disabled: true,
                checked: false
            }
        }
    } else {
        propsCopy.options.selectionProps = () => props.options.selectionProps;
    }

    useEffect(() => {
        dispatchCheckedRows();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.options, raspberryEraseStation])

    const startAction = propsCopy.actions.find(a => a.name === 'start-session');
    if (startAction) {
        startAction.disabled = ["starting", "analyze", "erasure_inprogress"].includes(sessionStatus) || !propsCopy.data.SocketID || props.data.tableData.checked;
    }

    const resetAction = propsCopy.actions.find(a => a.name === 'reset');
    if (resetAction && (!sessionStatus || !["ready", "completed", ""].includes(sessionStatus))) {
        resetAction.disabled = false;
    } else {
        resetAction.disabled = true;
    }

    delete propsCopy["classes"];
    delete propsCopy["startSession"];
    delete propsCopy["abortSession"];
    delete propsCopy["activeCustomerID"];

    return (
        <MTableBodyRow {...propsCopy} data={storeData}/>
    )
}

const mapDispatchToProps = dispatch => {
    return {
        startSession: data => dispatch(raspberryEraseStationActions.startSession(data)),
        abortSession: data => dispatch(raspberryEraseStationActions.abortSession(data)),
    }
};

export default connect(null, mapDispatchToProps)(withStyles(styles, {withTheme: true})(RaspberryEraseStationListRow));